import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Chip,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import LoanEnquiryModal from "./LoanEnquiryModal";
import EnquiryConsentModal from "./EnquiryConsentModal";
import TermsConditionsModal from "./TermsConditionsModal";

const LoanCard = ({ loanData, onClose }) => {
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
    const [isTermsModalOpen, setIsTermsModalOpen] = useState(false); 
  const [loading, setLoading] = useState(false);

  // const handleEnquireNow = () => {
  //   setLoading(true);

  //   setLoading(false);
  //   setIsSecondModalOpen(true); // Open LoanEnquiryModal after enquiry
  //   // Close the current modal
  // };

  // const handleCloseSecondModal = () => {
  //   setIsSecondModalOpen(false); // Close LoanEnquiryModal
  // };

    const handleEnquireNow = () => {
    setLoading(true);
    setIsTermsModalOpen(true); // Open Terms and Conditions Modal on Enquire Now
    setLoading(false);
  };

  const handleCloseTermsModal = () => {
    setIsTermsModalOpen(false); // Close Terms and Conditions Modal
  };

  const handleCloseSecondModal = () => {
    setIsSecondModalOpen(false); // Close EnquiryConsentModal
  };

  const handleEnquireNowFromTerms = () => {
    setIsTermsModalOpen(false); // Close Terms Modal
    setIsSecondModalOpen(true); // Open EnquiryConsentModal
  };
  return (
    <Card
      sx={{
        width: "100%",
        borderRadius: "16px",
        boxShadow: "0px 4px 4px rgba(0,0,0,0.1)", // Reduced box-shadow to make it lighter
        fontFamily: "Inter-medium, sans-serif",

        position: "relative",
        backgroundColor: "#fff",
        height: "auto", // Ensures height adjusts based on content
      }}
    >
      {/* Popular Badge */}
      {loanData.isPopular && (
        <Chip
          label="★ Popular"
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            backgroundColor: "#F59E0B",
            color: "#fff",
            fontWeight: 600,
            fontSize: "12px",
            height: "26px",
          }}
        />
      )}

      <CardContent sx={{ p: 2.5 }}>
        {" "}
        {/* Reduced padding here */}
        {/* Header */}
        <Box display="flex" alignItems="center" mb={1.5}>
          {" "}
          {/* Reduced bottom margin */}
          {/* <Box
            sx={{
              width: 45,
              height: 45,
              borderRadius: "12px",
              backgroundColor: loanData.bank_logo,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontWeight: 600,
              fontSize: "14px", // Reduced font size for the bank code
              mr: 1.5,
            }}
          >
            {loanData.bank_code}
          </Box> */}

          {/* Bank logo as image */}
          <Box
            sx={{
              width: 45,
              height: 45,
              borderRadius: "12px",
              overflow: "hidden", // Ensures image stays within rounded corner
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mr: 1.5,
            }}
          >
            {/* Display the bank logo image */}
            <img
              src={loanData.bank_logo} // Use the bank_logo URL
              // alt={loanData.bankName}
              style={{ width: "100%", height: "100%", objectFit: "cover" }} // Ensures image fits well
            />
          </Box>
          <Box>
            <Typography
              sx={{ fontSize: "16px", fontWeight: 600, color: "#111827" }}
            >
              {loanData.bank_name}
            </Typography>
            <Typography sx={{ fontSize: "13px", color: "#6B7280" }}>
              {loanData.loan_type}
            </Typography>
          </Box>
        </Box>
        {/* Rate Section */}
        <Box
          sx={{
            backgroundColor: "#F3F4F6",
            borderRadius: "12px",
            p: 1.5,
            mb: 1.5,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography sx={{ fontSize: "12px", color: "#6B7280", mb: 0.5 }}>
              Rate of Interest
            </Typography>
            <Typography
              sx={{ fontSize: "22px", fontWeight: 700, color: "#111827" }}
            >
              {loanData.min_roi}%
               {/* - {loanData.max_roi}% */}
               {" "}
              <span style={{ fontSize: 14, fontWeight: 500 }}>p.a.</span>
            </Typography>
          </Box>

          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundColor: "#D1FAE5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TrendingDownIcon sx={{ color: "#10B981" }} />
          </Box>
        </Box>
        {/* Loan Details */}
        <Box display="flex" justifyContent="space-between" mb={1.5}>
          {" "}
          {/* Reduced margin */}
          {/* <Box>
            <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
              EMI per ₹1 Lakh
            </Typography>
            <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
              ₹{loanData.emiPerLakh}
            </Typography>

            <Typography sx={{ fontSize: 12, color: "#6B7280", mt: 1 }}>
              Processing Fee
            </Typography>
            <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
              {loanData.processingFee}
            </Typography>
          </Box> */}
          <Box>
            <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
              Max Tenure
            </Typography>
            <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
              {loanData.tenure}
            </Typography>

            {/* <Typography sx={{ fontSize: 12, color: "#6B7280", mt: 1 }}>
              Prepayment
            </Typography>
            <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
              {loanData.prepayment}
            </Typography> */}
          </Box>
        </Box>
        {/* Features */}
        <Box mb={2}>
          {loanData.features.map((feature, index) => (
            <Box key={index} display="flex" alignItems="center" mb={0.5}>
              {" "}
              {/* Reduced margin */}
              {/* <CheckIcon sx={{ fontSize: 18, color: "#10B981", mr: 1 }} /> */}
              <Typography sx={{ fontSize: 13, color: "#374151" }}>
                {/* {loanData.features} */}
              </Typography>
            </Box>
          ))}
        </Box>
        {/* Button */}
        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#F59E0B",
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "10px",
            py: 1,
            fontSize: "14px", // Reduced font size for button
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#D97706",
              boxShadow: "none",
            },
          }}
          onClick={handleEnquireNow}
          disabled={loading}
        >
          Enquire Now
        </Button>
      </CardContent>

      {/* Terms and Conditions Modal */}
      <TermsConditionsModal
        open={isTermsModalOpen}
        onClose={handleCloseTermsModal}
        onEnquireNow={handleEnquireNowFromTerms} // Handle Enquire Now from Terms Modal
      />
      {/* Loan Enquiry Modal */}
      <EnquiryConsentModal
        open={isSecondModalOpen}
        onClose={handleCloseSecondModal}
        bankEmail={loanData.email}
        loanData={loanData}
      />
    </Card>
  );
};

export default LoanCard;
